module.exports = __webpack_public_path__ + "img/Adressing_2.4d4b762a.jpg";